module.exports = __webpack_public_path__ + "static/img/logo-3-2.e14e929f.png";